import { addStream } from '../../epicStore'
import { merge, Observable, fromEvent } from 'rxjs'
import { pluck, map, tap, mapTo } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import * as actions from '../../../actions'
import { debug } from '@bt-react/libs/Logger'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { TwilioBridgeDataDocInterface } from '../../../reducers/docs/types'
import { setActiveBridge, docBridgeDataListenersAdded } from '../../../actions/setup/setupActions'
import getActiveBridgeFromDoc from '../../../../lib/getActiveBridgeFromDoc'
import { removeBridgeDataDocument } from '../../../actions/docs/docsActions'

export const events$ = (doc: TwilioBridgeDataDocInterface): Observable<ReduxAction> => merge(
  fromEvent<{ data: TwilioBridgeDataDocInterface['data'], isLocal?: boolean }>(doc, 'updated')
    .pipe(
      pluck('data'),
      map(docValue => setActiveBridge(getActiveBridgeFromDoc(docValue)))
    ),
  fromEvent(doc, 'removed')
    .pipe(
      map(() => {

        debug(`Booking document has been removed`)
        return removeBridgeDataDocument()

      })

    )
)

const addBridgeDataEvents$ = (actions$, state: { value: State }) => actions$.pipe(
  ofType(actionTypes.SET_BRIDGE_DATA_DOCUMENT),
  pluck('payload'),
  map((doc: TwilioBridgeDataDocInterface) => events$(doc)),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  mapTo(docBridgeDataListenersAdded())

)

export default addBridgeDataEvents$
